import * as _ from 'lodash'
import {
  IPlanCalculator,
  IPlanCalculatorCalculateOptions,
  IPlanCalculatorCalculateResults
} from "../PA.TPM.Core/PA.TPM.IF.TPM.Plan.Aspects";
import {IMessageProvider, IProgressProvider, MessageType} from "../PA.Core/PA.Core.IF.Basic";
import {MessageProvider} from "../PA.Core/Basic/Messages";
import {ProgressProvider} from "../PA.Core/Basic/Progress";
import {TPMPlanBO} from "../PA.TPM.BusinessObjects/TPMPlanBO";
import {PlanningService} from "./PlanningService";

export class TPMPlanCalculator
  implements  IPlanCalculator {

  private _calcMessageProvider: MessageProvider;
  private _calcProgressProvider: ProgressProvider;
  private _tpmPlanBO: TPMPlanBO

  constructor(){
    this._calcMessageProvider = new MessageProvider()
    this._calcProgressProvider = new ProgressProvider()
    this._tpmPlanBO = undefined
  }

  Register(aTPMPlanBO: TPMPlanBO): void {

    // Currently, we don't listen to anything,.. just on demand calc.
    this.UnRegister()
    this._tpmPlanBO = aTPMPlanBO
  }

  UnRegister(): void {
    this._tpmPlanBO = undefined
  }


  get CalcProgressProvider(): IProgressProvider {
    return this._calcProgressProvider
  }

  get CalcMessageProvider(): IMessageProvider {
    return this._calcMessageProvider
  }


  // Calculate Steps
  // 1. Save (Validate)
  // 2. Run CalcPlan
  // 3. Reload BO
  Calculate(opts: IPlanCalculatorCalculateOptions): Promise<IPlanCalculatorCalculateResults> {
    const self = this

    return new  Promise<IPlanCalculatorCalculateResults>((resolve, error) => {
      if(_.isEmpty(self._tpmPlanBO)){
        resolve()
        return
      }

      self.CalcMessageProvider.clearMessages()
      self.CalcProgressProvider.start("Calculating Plan")
      self.CalcProgressProvider.setProgressMessage('Saving', 'Validating and Saving Plan')
      // 1. Save (Validate)
      self._tpmPlanBO.Save()
        .then((bo) => {
          if(!bo.bIsSaved){
            self.CalcProgressProvider.setProgressMessage('Saving', 'Unable to Save Plan to Calculate')
            self.CalcProgressProvider.finish()
            resolve()
            return
          }

          // 2. Run CalcPlan
          self.CalcProgressProvider.setProgressMessage('Calculating', 'Calculating Plan')

          let aPlanningService = new PlanningService()
          return aPlanningService.calculatePlan({WB_PLAN_ID: self._tpmPlanBO.WB_Plan.cif.WB_PLAN_ID,
              bWriteVolumeMetrics: true,
              bWriteMonthlyMetrics: false,
              bWriteFundingMetrics: true,
              bWriteActuals: true,
              bWriteSpendMetrics: false,
              bWriteEventMetrics: false})
        })
        .then((results) => {
          if(results.bSuccess){
            self.CalcMessageProvider.addMessage({code: 'Success', type: MessageType.Information,
              title: 'Calculation Completed', description: 'Calculation Completed'})
          }

          // Add Any Warnings
          _.forEach(results.sWarnings, (aWarning) => {
            self.CalcMessageProvider.addMessage({
              code: 'Warning', type: MessageType.Warning,
              title: aWarning, description: aWarning
            })
          })

          _.forEach(results.sErrors, (anError) => {
            self.CalcMessageProvider.addMessage({
              code: 'Error', type: MessageType.Error,
              title: anError, description: anError
            })
          })

          // 3. Reload BO
          self.CalcProgressProvider.setProgressMessage('Reloading', 'Reloading Plan')
          return self._tpmPlanBO.Reload()
        })
        .then(() => {
          self.CalcProgressProvider.finish()
          resolve({})
        })
        .catch((err) => {
          self.CalcProgressProvider.exception(err)
          error(err)
        })

    })
  }


}